import { makeStyles } from "@material-ui/core";

export default makeStyles(() => ({
    ul: {
        justifyContent: 'space-round',
        // backgroundColor: 'rgba(255, 255, 255, 0.7)',
        // boxShadow: '0 10px 60px -10px rgba(13, 28, 39, .5)',
        backdropFilter: 'blur(10spx)', borderRadius: '10px'
    }
}))
